module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('section', {
    staticClass: "chapter",
    attrs: {
      "epub:type": "chapter",
      "id": "structure_1",
      "role": "doc-chapter"
    }
  }, [_c('div', {
    staticClass: "epigraph",
    attrs: {
      "role": "doc-epigraph"
    }
  }, [_c('p', {
    staticClass: "epf"
  }, [_c('span', {
    staticClass: "page",
    attrs: {
      "aria-label": "vi",
      "id": "pvi",
      "role": "doc-pagebreak"
    }
  }), _vm._v("Teaching is about taking things apart; writing is about putting things together.")]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_vm._v("TONI MORRISON, INTERVIEWED BY HILTON ALS IN THE "), _c('i', [_vm._v("NEW YORKER")]), _vm._v(" (2003)")]), _vm._v(" "), _c('p', {
    staticClass: "epf"
  }, [_vm._v("What’s the story, morning glory?")]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_vm._v("“THE TELEPHONE HOUR,” FROM THE MUSICAL "), _c('i', [_vm._v("BYE BYE BIRDIE")]), _vm._v(" (1960) (ALSO THE TITLE OF A 1995 ALBUM BY OASIS)")]), _vm._v(" "), _c('p', {
    staticClass: "epf"
  }, [_vm._v("You must not take what I say as definite at all ever, but all as by way of example only. The whole thing might perhaps be done in some quite different way, and what I say are only suggestions toward the final effect. The ways and means to it may be different from what I have used to illustrate.")]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_vm._v("EDITOR MAX PERKINS, OFFERING WRITING ADVICE TO MARJORIE KINNAN RAWLINGS (WINNER OF THE 1939 PULITZER PRIZE IN LITERATURE FOR HER NOVEL "), _c('i', [_vm._v("THE YEARLING")]), _vm._v(")")]), _vm._v(" "), _c('p', {
    staticClass: "epf"
  }, [_vm._v("O rocks! Tell us in plain words.")]), _vm._v(" "), _c('p', {
    staticClass: "ept"
  }, [_vm._v("MOLLY BLOOM, WANTING CLARIFICATION, IN "), _c('i', [_vm._v("ULYSSES")]), _vm._v(" (1922)")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5127d4ba","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chi-germano-0007.vue
// module id = 72
// module chunks = 0